import React from 'react';
import Collapse, { Panel } from 'rc-collapse';

interface Props {
  isOpened?: boolean;
  children: React.ReactNode;
}

const GenericCollapse = ({ isOpened, children, ...restProps }: Props) => (
  <Collapse activeKey={isOpened ? '0' : []} {...restProps}>
    <Panel showArrow={false} forceRender>
      {children}
    </Panel>
  </Collapse>
);

export default GenericCollapse;
